// @flow
import { path } from 'ramda'

import type { MediaStreamType } from '@alphaott/api-client/types/mediaStream'
import type { Sources } from '@alphaott/api-client/types/source'
import type { DRM } from '@alphaott/api-client/types/drm'
import type { DRMProps } from '@alphaott/video-player'

import { getVideoType } from '../preparePlayerSources'
import preparedDRM from './preparedDRM'

type BaseMediaStream = {
  type: MediaStreamType,
  sources: Sources,
  drm: ?DRM,
  p2p?: boolean,
}

export type PreparedSource = {
  sources: ?Sources,
  type: ?string,
  drm: ?DRMProps,
  p2p?: boolean,
}

export const prepareShakaPlayerSources = (mediaStream: BaseMediaStream): PreparedSource => {
  const { sources = [], type, drm } = mediaStream
  const src = path(['0', 'src'], sources)

  return {
    sources: sources.map(source => ({
      src: source.src,
    })),
    type: getVideoType(type),
    drm: preparedDRM(drm, src),
    ...(mediaStream.p2p && {
      p2p: mediaStream.p2p,
    }),
  }
}

export default prepareShakaPlayerSources
